import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Form, FormGroup, FormControl, ControlLabel, Button, Checkbox, Image } from 'react-bootstrap'
import uploadedImage from '../../../../images/cr-logo-new.png'
import Api from './../../../Global/Modules/Api'
import { Editor } from '@tinymce/tinymce-react';
const FETCH_URL = "api/news/admin/"
class MededelingEdit extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.handleEditorChange = this.handleEditorChange.bind(this)
        this.handleOptionsChange = this.handleOptionsChange.bind(this)
        this.state = {
            id: this.props.id,
            title: "",
            deleteImage: "",
            description: "",
            message: "",
            options: {
                0: false,
                1: false,
                2: false
            }
        }
    }
    componentWillMount() {
        this.getNewsDetail(this.props.id)
    }
    handleEditorChange = (e) => {
        this.setState({ message: e.target.getContent() })
    }
    getNewsDetail(id) {
        Api.GetApi(FETCH_URL + id, this.props.history).then(news => {
            if (news !== undefined) {
                this.setState({ options: { ...this.state.options, 0: news.visible, 1: news.homepage, 2: news.top } })
                this.setState({ title: news.title, })
                this.setState({ image: news.image, })
                this.setState({ message: news.message, })
                this.setState({ description: news.description, })
            }


        })
    }
    // Function that will be executed when the submit button (Toevoegen) is pressed
    handleSubmit(event) {
        event.preventDefault()
        var formData = new FormData()
        Object.keys(this.state).forEach(e => {
            if (e === "message") formData.append(e, this.state.message.toString('html'))
            else {
                if (e == "options") {
                    formData.append("visible", this.state[e][0])
                    formData.append("homepage", this.state[e][1])
                    formData.append("top", this.state[e][2])
                } else {
                    formData.append(e, this.state[e])
                }
            }

        })

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)


        // TODO: Post payload to the API
        Api.PostApiWithFile("api/news", formData, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    Api.print(response)
                    this.setState({ errors: response });
                }
                else {
                    alert("News updated")
                    window.location.href = '/admin/mededelingen';
                }
            })
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.type === 'checkbox' ? target.checked : target.value
        this.setState({ [name]: value })
    }

    // Function to manage the changes of the option checkboxes
    handleOptionsChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        const checked = target.checked
        this.setState({ [name]: { ...this.state[name], [value]: checked } })
    }

    render() {

        return (
            <div>
                <Row>
                    <Form horizontal onSubmit={this.handleSubmit}>
                        <Col md={8}>
                            <FormGroup controlId="MededelingToevoegenTitel">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Titel *
                                </Col>
                                <Col sm={6}>
                                    <FormControl type="text" name="title" value={this.state.title} required onChange={this.handleChange} />
                                    {/**<FormControl type="text" placeholder="" defaultValue="Toetsing 9 April" />**/}
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="MededelingToevoegenAfbeelding">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Afbeelding
                                </Col>
                                <Col sm={6}>
                                    <FormControl type="File" inputRef={input => this.fileInput = input} />
                                    <Checkbox name="deleteImage" value={this.state.deleteImage} onChange={this.handleChange}>Verwijder afbeelding</Checkbox>
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="MededelingToevoegenKortBeschrijving">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Korte beschrijving
                                </Col>
                                <Col sm={6}>
                                    {/**<FormControl componentClass="textarea" rows="5" placeholder="" defaultValue="De toetsing zal op 9 April zijn" />**/}
                                    <FormControl componentClass="textarea" rows="5" name="description" value={this.state.description} onChange={this.handleChange} />
                                </Col>
                            </FormGroup>


                            <FormGroup controlId="MededelingToevoegenOpties">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Opties
                                </Col>
                                <Col sm={6}>
                                    {Api.getCommunicationOptions().map((option, index) =>
                                        <Checkbox
                                            name="options"
                                            value={index}
                                            key={"option" + index}
                                            checked={this.state.options[index]}
                                            onChange={this.handleOptionsChange}>
                                            {option}
                                        </Checkbox>
                                    )}
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            Gekozen afbeelding:<br />
                            <Image src={this.state.image == 'news/' ? uploadedImage : Api.Url + this.state.image} thumbnail />
                        </Col>
                        <Col md={8}>
                            <FormGroup controlId="MededelingToevoegenBericht">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Bericht *
                                </Col>
                                <Col sm={8}>
                                    <Editor
                                        apiKey='xf2qbgxw2woyqnls6pdrup90dwguymnu1rzauht57kh622am'
                                        initialValue={this.state.message}
                                        init={{
                                            height: 500,
                                            menubar: false,
                                            image_generaltab: false,
                                            images_upload_handler: function (blobInfo, success, failure) {
                                                var formData;
                                                formData = new FormData();
                                                formData.append('file', blobInfo.blob(), blobInfo.filename());

                                                Api.PostApiWithFileCMS('api/pages/file', formData, null)
                                                    .then(response => { success(Api.Url + response.url); })
                                            },
                                            relative_urls: false,
                                            plugins: [
                                                'advlist autolink lists link image charmap print preview anchor',
                                                'searchreplace visualblocks code fullscreen forecolor fontsizeselect',
                                                'insertdatetime media table paste code help wordcount '
                                            ],
                                            toolbar:
                                                'undo redo | formatselect fontsizeselect | bold italic underline |  forecolor backcolor charmap | superscript subscript | \
                                        alignleft aligncenter alignright alignjustify | \
                                        bullist numlist outdent indent | removeformat link | image table code'
                                        }}
                                        onChange={this.handleEditorChange}
                                    />
                                </Col>
                            </FormGroup>

                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <Col sm={12}>
                                    <LinkContainer to="/admin/mededelingen"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                                    <Button type="submit" className="pull-right">Toevoegen</Button>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Form>
                </Row>
            </div>
        );
    }
}

export default MededelingEdit;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Mededelingen/Edit.js